// extracted by mini-css-extract-plugin
module.exports = {"box-default":"section-visual_box-default__32X7y box_pad-vertical__YM6tX","visual":"section-visual_visual__KRzl_","fade":"section-visual_fade__njaSY"};